import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { Paper, Box, Tab, Tabs, } from "@mui/material";
import { useSelector } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useAlert } from "react-alert";
import { useSnackbar } from "../../hooks";
import logger from "../../helpers/logger";

import SiteUsersTable from "./SiteUsersTable";

import ManageRolesModal from "../../components/SiteUsers/ManageRolesModal";

import SiteUserHeader from "./SiteUsersHeader";
import SiteSelectModal from "../../components/common/SiteSelectModal";
import { useGetSiteRoles } from "../../hooks/useGetSiteRoles";

import { FILTER_NAMES } from "./SiteUsersTable/filters";
import InviteUsersModals from "../../components/SiteUsers/InviteUserModals";
import ManageMissingTable from "./ManageMissingTable";
import { LIST_COMPANY_ACCOUNTAPPLICATIONS } from "../../graphql/queries";

const { UNORDERED } = FILTER_NAMES;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  paper: {
    boxShadow: "0 6px 10px -4px rgba(0, 0, 0, 0.15)",
    borderRadius: 3,
  },

  paperBody: {
    padding: theme.spacing(4),
  },
}));

function CustomTabPanel(props) {
  const { children, value, index, bgColor, AdjustForGrid, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ margin: "32px -24px 8px -24px", padding: "0px 24px 0px 24px", borderRadius: "0 0 4px 4px", background: bgColor ? bgColor : "#f4f3ed", minHeight: "100%", height: "100%", }}
    >
      {value === index && (
        <Box component="div">
          {children}
        </Box>
      )}
    </div>
  );
}


const AccountApplications = ({ }) => {
  const classes = useStyles();
  const intl = useIntl();
  const alert = useAlert();
  const snackbar = useSnackbar();
  const selectedWorkspace = useSelector(
    state => state.ui.toggleWorkspaces.workspace
  );

  const [tabValue, setTabValue] = useState(0);
  const sxTab = { textTransform: "none", fontSize: "12px", minHeight: "28px", height: "28px", paddingBottom: 0, marginTop: "0px", paddingTop: "2px" };
  const sxTabs = { minHeight: "28px", height: "28px" };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [selectedSite, setSelectedSite] = useState(
    (selectedWorkspace && selectedWorkspace.id) || null
  );
  const [selectedWorkspaceName, setSelectedWorkspaceName] = useState(
    (selectedWorkspace && selectedWorkspace.name) || null
  );

  const [filter, setFilter] = useState("SHOW_ALL");

  const siteUsers = useSelector(state => state.api.siteUsers.items);
  const siteUsersLoading = useSelector(state => state.api.siteUsers.loading);

  const filterOptions = [
    {
      label: intl.formatMessage({
        id: "siteUsers.showAllUsers",
      }),
      value: "SHOW_ALL",
    },
    {
      label: intl.formatMessage({
        id: "siteUsers.showInvitedUsers",
      }),
      value: "SHOW_INVITED",
    },
    {
      label: intl.formatMessage({
        id: "siteUsers.showActiveUsers",
      }),
      value: "SHOW_ACTIVE",
    },
    {
      label: intl.formatMessage({
        id: "siteUsers.showInactiveUsers",
      }),
      value: "SHOW_INACTIVE",
    },
  ];

  const sites = useSelector(state => state.api.currentViewer.viewer.sites);

  const siteRoles = useSelector(state => state.api.siteUsers.siteRoles);
  const [sortfield, setSortfield] = useState(UNORDERED);
  const [ascending, setAscending] = useState(false);
  const [siteRolesRights, setSiteRolesRights] = useState({});

  const [siteSelect, setSiteSelect] = useState(false);
  const [openManageRoles, setOpenManageRoles] = useState(false);
  const [currentApplication, setCurrentApplication] = useState();

  const { execute: getSiteRoles } = useGetSiteRoles({
    siteId: selectedSite,
  });

  const [ listAcountApplications, { data, loading, error }] = useLazyQuery(LIST_COMPANY_ACCOUNTAPPLICATIONS);
  const [applications, setApplications] = useState([]);


  useEffect(() => {
    if (selectedSite) {
      getSiteRoles();
    }

  }, [selectedSite])

  useEffect(() => {
    if (data) {
      var users = data?.companyAdminContext?.users?.accountApplications;
      setApplications(users);

    }
    else
    {
      fetchApplications();
    }

  }, [data, loading, error])

  const fetchApplications = () => {
    listAcountApplications({ variables: { companyId: 20 } });
  }

  const options = [{ label: "Välj arbetsyta här", value: 0 }];
  sites.forEach(site => {
    options.push({
      label: site.name,
      value: site.id,
      orderGroupId: site.orderGroupId,
    });
  });

  const handleSetSiteId = site => {
    const { siteId } = site;
    if (siteId !== 0) {
      setSelectedSite(siteId);
      setSelectedWorkspaceName(site.name);
      const siteRoleRights = sites.filter(site => site.id === siteId);
      setSiteRolesRights(siteRoleRights[0].siteRoleRights);
    }
  };

  const siteRoleOptions = siteRoles.map(x => {
    return { label: x.name, value: x.siteRoleId };
  });

  const [openInviteModals, setOpenInviteModals] = useState(false);

  const handleOpenInviteUser = (id, email) => {
    if (!selectedSite) {
      setSiteSelect(true); // prompt for site selection
      return;
    }

    setCurrentApplication([email]);
    setOpenInviteModals(true);
  };
  

  const handleCloseInviteUser = () => {
    setOpenInviteModals(false);
    setCurrentApplication([]);
  };




  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={0}>
        <SiteUserHeader
          filter={filter}
          filterOptions={filterOptions}
          setFilter={setFilter}
          handleOpenInviteUser={handleOpenInviteUser}
          handleSetSiteId={handleSetSiteId}
          options={options}
          selectedSite={selectedSite}
          selectedWorkspaceName={selectedWorkspaceName}
          siteRolesRights={siteRolesRights}
        />

        <Tabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Project Menu scrollable auto"
          sx={sxTabs}
        >
          <Tab sx={sxTab} label={"Ansökningar"} {...a11yProps(0)} />
          <Tab sx={sxTab} label={"Komplettera registrering"} {...a11yProps(1)} />
        </Tabs>

        <Box className={classes.paperBody}>

          <CustomTabPanel value={tabValue} index={0} bgColor="#ffffff">
            <SiteUsersTable
              fetchApplications={fetchApplications}
              onInviteSiteUser={handleOpenInviteUser}
              siteRoleOptions={siteRoleOptions}
              sortfield={sortfield}
              ascending={ascending}
              setSortfield={setSortfield}
              setAscending={setAscending}
              siteRolesRights={siteRolesRights}
              applications={applications}
              siteUsersLoading={siteUsersLoading}
            />
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={1} bgColor="#ffffff">
            <ManageMissingTable />
          </CustomTabPanel>
        </Box>
      </Paper>
      {
        siteSelect && (
          <SiteSelectModal open={siteSelect} setOpen={setSiteSelect} />
        )
      }

      <InviteUsersModals
        open={openInviteModals}
        onCloseDialog={handleCloseInviteUser}
        selectedSite={selectedSite}
        siteRoleOptions={siteRoleOptions}
        getSiteUsers={fetchApplications}
        setSiteSelect={setSiteSelect}
        isShareModal={false}
        preparedEmails={currentApplication}
      />

      {
        openManageRoles && (
          <ManageRolesModal
            open={openManageRoles}
            selectedSite={selectedSite}
            selectedWorkspaceName={selectedWorkspaceName}
            setOpenManageRoles={setOpenManageRoles}
            siteRoles={siteRoles}
            siteRoleOptions={siteRoleOptions}
          />
        )
      }
    </div >
  );

}

export default AccountApplications;